module.exports = __webpack_public_path__ + "img/1493441439.9947a77e.jpg";